import { type Country, isCountry } from "@shared/types.js";

const KEY = "rate2728.country";

/**
 * Which Masterfile the dashboard is showing. The choice sticks per browser so
 * someone who works one country does not re-pick it every morning, and the URL
 * still wins so a shared link lands on the country it was taken from.
 */
export function readCountry(search = window.location.search): Country {
  const fromUrl = new URLSearchParams(search).get("country");
  if (isCountry(fromUrl)) return fromUrl;
  try {
    const saved = localStorage.getItem(KEY);
    if (isCountry(saved)) return saved;
  } catch { /* private mode: fall through to the default */ }
  return "ID";
}

export function saveCountry(c: Country): void {
  try {
    localStorage.setItem(KEY, c);
  } catch { /* private mode: the choice just will not persist */ }
}
